"use strict";
/*

 MIT License

 Copyright (c) 2024 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedConnection = void 0;
var DashboardConnection_1 = require("./DashboardConnection");
var ExploreConnection_1 = require("./ExploreConnection");
var ExtensionConnection_1 = require("./ExtensionConnection");
var LookConnection_1 = require("./LookConnection");
var QueryVisualizationConnection_1 = require("./QueryVisualizationConnection");
var ReportConnection_1 = require("./ReportConnection");
var EmbedConnection = /** @class */ (function () {
    function EmbedConnection(_host, _embedClient) {
        this._host = _host;
        this._embedClient = _embedClient;
        this._pageType = 'unknown';
        this._isEditing = false;
        this._currentPathname = '';
    }
    EmbedConnection.prototype.send = function (message, params) {
        this._host.send(message, params);
    };
    EmbedConnection.prototype.sendAndReceive = function (message, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._host.sendAndReceive(message, params)];
            });
        });
    };
    EmbedConnection.prototype.getLookerVersion = function () {
        if (this._embedClient._lookerVersion === undefined) {
            return -1;
        }
        return this._embedClient._lookerVersion;
    };
    EmbedConnection.prototype.loadUrl = function (_a) {
        var url = _a.url, _b = _a.pushHistory, pushHistory = _b === void 0 ? false : _b, options = _a.options;
        return __awaiter(this, void 0, void 0, function () {
            var pageChangePromise, pageLoadPromise;
            var _this = this;
            return __generator(this, function (_c) {
                if (!this._embedClient.isPageLoadEventSupported) {
                    return [2 /*return*/, Promise.reject(new Error("The 'page:load' action requires Looker version 25.2.0 or greater"))];
                }
                switch (this._pageType) {
                    case 'dashboards':
                        this.asDashboardConnection().stop();
                        break;
                }
                pageChangePromise = (options === null || options === void 0 ? void 0 : options.waitUntilLoaded)
                    ? new Promise(function (resolve) {
                        _this._embedClient._pageChangeResolver = resolve;
                    })
                    : undefined;
                pageLoadPromise = this.sendAndReceive('page:load', {
                    pushHistory: pushHistory,
                    url: this._embedClient.appendRequiredParameters(url),
                });
                return [2 /*return*/, (options === null || options === void 0 ? void 0 : options.waitUntilLoaded) ? pageChangePromise : pageLoadPromise];
            });
        });
    };
    EmbedConnection.prototype.loadId = function (_a) {
        var type = _a.type, id = _a.id, pushHistory = _a.pushHistory, options = _a.options;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.loadUrl({
                        options: options,
                        pushHistory: pushHistory,
                        url: "/embed/".concat(type, "/").concat(id),
                    })];
            });
        });
    };
    EmbedConnection.prototype.loadDashboard = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._embedClient.isPageLoadEventSupported) {
                    return [2 /*return*/, this.loadId({
                            id: id,
                            options: options,
                            pushHistory: pushHistory,
                            type: 'dashboards',
                        })];
                }
                switch (this._pageType) {
                    case 'dashboards':
                        return [2 /*return*/, this.sendAndReceive('dashboard:load', {
                                id: id,
                                pushHistory: pushHistory || false,
                            })];
                }
                return [2 /*return*/];
            });
        });
    };
    EmbedConnection.prototype.loadExplore = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                id = id.replace('::', '/'); // Handle old format explore ids.
                return [2 /*return*/, this.loadId({ id: id, options: options, pushHistory: pushHistory, type: 'explore' })];
            });
        });
    };
    EmbedConnection.prototype.loadMergeQuery = function (id, pushHistory, options) {
        return this.loadUrl({
            options: options,
            pushHistory: pushHistory,
            url: "/embed/merge?mid=".concat(id),
        });
    };
    EmbedConnection.prototype.loadQuery = function (model, view, qid, pushHistory, options) {
        return this.loadUrl({
            options: options,
            pushHistory: pushHistory,
            url: "/embed/query/".concat(model, "/").concat(view, "?qid=").concat(qid),
        });
    };
    EmbedConnection.prototype.loadLook = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadId({
                        id: id,
                        options: options,
                        pushHistory: pushHistory,
                        type: 'looks',
                    })];
            });
        });
    };
    EmbedConnection.prototype.loadExtension = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadId({ id: id, options: options, pushHistory: pushHistory, type: 'extensions' })];
            });
        });
    };
    EmbedConnection.prototype.loadQueryVisualization = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadId({
                        id: id,
                        options: options,
                        pushHistory: pushHistory,
                        type: 'query-visualization',
                    })];
            });
        });
    };
    EmbedConnection.prototype.loadReport = function (id, pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadId({
                        id: id,
                        options: options,
                        pushHistory: pushHistory,
                        type: 'reporting',
                    })];
            });
        });
    };
    EmbedConnection.prototype.preload = function (pushHistory, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.loadUrl({ options: options, pushHistory: pushHistory, url: '/embed/preload' })];
            });
        });
    };
    EmbedConnection.prototype.asDashboardConnection = function () {
        return new DashboardConnection_1.DashboardConnection(this);
    };
    EmbedConnection.prototype.asExploreConnection = function () {
        return new ExploreConnection_1.ExploreConnection(this);
    };
    EmbedConnection.prototype.asExtensionConnection = function () {
        return new ExtensionConnection_1.ExtensionConnection(this);
    };
    EmbedConnection.prototype.asLookConnection = function () {
        return new LookConnection_1.LookConnection(this);
    };
    EmbedConnection.prototype.asQueryVisualizationConnection = function () {
        return new QueryVisualizationConnection_1.QueryVisualizationConnection(this);
    };
    EmbedConnection.prototype.asReportConnection = function () {
        return new ReportConnection_1.ReportConnection(this);
    };
    EmbedConnection.prototype.getPageType = function () {
        return this._pageType;
    };
    EmbedConnection.prototype.isEditing = function () {
        return this._isEditing;
    };
    EmbedConnection.prototype.hasSessionExpired = function () {
        return this._embedClient._hasSessionExpired;
    };
    // deprecated methods to support migration from 1.18.x to 2.0.0
    /**
     * @deprecated use asXXXConnection().run() instead
     */
    EmbedConnection.prototype.run = function () {
        switch (this._pageType) {
            case 'dashboards':
                this.asDashboardConnection().run();
                break;
            case 'looks':
                this.asLookConnection().run();
                break;
            case 'explore':
                this.asLookConnection().run();
                break;
        }
    };
    /**
     * @deprecated use asDashboardConnection().stop() instead
     */
    EmbedConnection.prototype.stop = function () {
        switch (this._pageType) {
            case 'dashboards':
                this.asDashboardConnection().stop();
                break;
        }
    };
    /**
     * @deprecated use asDashboardConnection().edit() instead
     */
    EmbedConnection.prototype.edit = function () {
        switch (this._pageType) {
            case 'dashboards':
                this.asDashboardConnection().edit();
                break;
        }
    };
    /**
     * @deprecated use asXXXConnection().updateFilters(params) instead
     */
    EmbedConnection.prototype.updateFilters = function (params) {
        switch (this._pageType) {
            case 'dashboards':
                this.asDashboardConnection().updateFilters(params);
                break;
            case 'looks':
                this.asLookConnection().updateFilters(params);
                break;
            case 'explore':
                this.asLookConnection().updateFilters(params);
                break;
        }
    };
    /**
     * @deprecated use asDashboardConnection().setOptions(options) instead
     */
    EmbedConnection.prototype.setOptions = function (options) {
        switch (this._pageType) {
            case 'dashboards':
                this.asDashboardConnection().setOptions(options);
                break;
        }
    };
    /**
     * @deprecated use asDashboardConnection().openScheduleDialog() instead
     */
    EmbedConnection.prototype.openScheduleDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (this._pageType) {
                    case 'dashboards':
                        return [2 /*return*/, this.asDashboardConnection().openScheduleDialog()];
                }
                return [2 /*return*/];
            });
        });
    };
    return EmbedConnection;
}());
exports.EmbedConnection = EmbedConnection;
//# sourceMappingURL=EmbedConnection.js.map